export type SelectorSection = {
  label: string
  description: string
  datasetIds: string[]
}

export const SELECTOR_SECTIONS: SelectorSection[] = [
  {
    label: 'Sentinel-1 GRD',
    description:
      'Sentinel-1 IW GRD product (EOPF zarr v3) over southern Italy, acquired 2024-02-01. 4-level multiscale pyramid, dual-polarization (VV/VH).',
    datasetIds: ['eopf-s1-grd'],
  },
  {
    label: 'Sentinel-2 L1C',
    description:
      'Sentinel-2A MSI L1C (TOA reflectance) over Austria, tile T32UPU, acquired 2026-07-21. 3-level multiscale pyramid.',
    datasetIds: ['eopf-s2-l1c'],
  },
  {
    label: 'Sentinel-2 L2A',
    description:
      'Sentinel-2C MSI L2A (BOA reflectance) over Austria, tile T32UQU, acquired 2026-07-16. 3-level multiscale pyramid.',
    datasetIds: ['eopf-s2-l2a'],
  },
]
